module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro-norming.292b90ac.mp3";